import React, { useEffect, useState } from 'react'
import { getPdf } from '../../services/pdf'
import { Viewer } from '@react-pdf-viewer/core'
import '@react-pdf-viewer/core/lib/styles/index.css'
import { Worker } from '@react-pdf-viewer/core'
import { useParams } from 'react-router'
import { getFilePlugin } from '@react-pdf-viewer/get-file';
import { jsPDF } from "jspdf";
import './../styles/style.css'
import bootstrap from 'bootstrap'

const Principal = () => {

    const { sponsor, nombrepdf } = useParams();
    const [pdf, setPdf] = useState('')

    const generarPDF = () => {
        const doc = new jsPDF("p", "pt", "a4")
        doc.html(document.querySelector('#idDocumentoPdf'), {
            callback: function (pdf) {
                // let pageCount = doc.internal.getNumberOfPages()
                // pdf.deletePage(pageCount)
                pdf.save(`${nombrepdf}`)
            }
        })
    }

    const getFilePluginInstance = getFilePlugin();

    useEffect(() => {
        getPdf(sponsor, nombrepdf).then(respuesta => {
            setPdf(respuesta.pdfUrl)
        })
    }, [])

    return (
        <div>

            <center >
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                  
 

                       
                            <div class="modal-body">Al final del docuento podrá descargarlo</div>
                      
                        <div className='pdf__visor' id='idDocumentoPdf'>
                            {
                                pdf ? <Viewer fileUrl={pdf} plugins={[getFilePluginInstance]} /> : <div>Cargando PDF ...</div>
                            }
                        </div>
                        <div class="modal-body">
                            <button onClick={generarPDF}  type="button" class="btn btn-primary">DESCARGAR PDF</button>
                        </div>
                  
                </Worker>
            </center>
        </div >
    )
}

export default Principal
